'use client';

import { c as _c } from "react/compiler-runtime";
import { useIsMounted } from 'design-system/client';
import { useActionFormContext } from '../ActionForm';
import type { FormSubmitButtonProps } from './types';
import { BaseSubmitButton } from '@/components/SubmitButton';
function FormSubmitButton(t0) {
  const $ = _c(8);
  let busy;
  let disabled__;
  let props;
  if ($[0] !== t0) {
    ({
      busy,
      disabled_: disabled__,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = busy;
    $[2] = disabled__;
    $[3] = props;
  } else {
    busy = $[1];
    disabled__ = $[2];
    props = $[3];
  }
  const {
    formState: t1
  } = useActionFormContext();
  const {
    isSubmitting
  } = t1;
  const disabled_ = !useIsMounted();
  const t2 = isSubmitting || busy || false;
  const t3 = disabled_ || disabled__;
  let t4;
  if ($[4] !== props || $[5] !== t2 || $[6] !== t3) {
    t4 = <BaseSubmitButton {...props} busy={t2} disabled_={t3} />;
    $[4] = props;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
export default FormSubmitButton;